module.exports = __webpack_public_path__ + "ed0907ea46c4eba0852e1d4cef6ae1f8.jpg";